<script setup lang="ts"></script>

<template>
  <ion-checkbox v-bind="$attrs" label-placement="end">
    <slot />
  </ion-checkbox>
</template>

<style scoped lang="scss">
ion-checkbox {
  --border-color: var(--ion-color-light-medium);
  --border-radius: 2px;
  --checkbox-background: transparent;

  &::part(label) {
    margin-inline-start: 0.5rem;
  }
}
</style>
